import React from 'react'
import PropTypes from 'prop-types'
import { message } from 'antd'
import WrappedModal from '@/components/WrappedModal'
import { updateTuinaReservation } from '@/service/tuina'
import ReservationRescheduleForm from './ReservationRescheduleForm'

const fromValue = (fields, record) => ({
  therapistId: fields.therapistId != null ? fields.therapistId : record.therapistId,
  appointmentDate: fields.appointmentDate != null ? fields.appointmentDate : record.appointmentDate,
  startTime: fields.startTime,
  remark: record && record.remark != null ? record.remark : ''
})

class ReservationRescheduleModal extends React.Component {
  static propTypes = {
    children: PropTypes.node,
    record: PropTypes.object,
    zIndex: PropTypes.number,
    onSuccess: PropTypes.func
  }

  handleOk = async (form) => {
    const { record, onSuccess } = this.props
    const fields = await form.current.validateFields()
    await updateTuinaReservation(record.id, fromValue(fields, record))
    message.success('已改约')
    if (typeof onSuccess === 'function') onSuccess()
  }

  render () {
    const { children, record, zIndex } = this.props
    return (
      <WrappedModal
        children={children}
        title="改约"
        okText="保存"
        okButtonProps={{ size: 'large' }}
        cancelButtonProps={{ size: 'large' }}
        width={560}
        zIndex={zIndex}
        wrapClassName="tuina-rsv-reschedule-wrap"
        className="tuina-rsv-reschedule-modal"
        baseComponent={<ReservationRescheduleForm />}
        baseProps={{ record }}
        onOk={this.handleOk}
      />
    )
  }
}

export default ReservationRescheduleModal
